export default "<div class=\"row\">\n  <div class=\"col\">\n    <p-breadcrumb [model]=\"menuItems\"></p-breadcrumb>\n  </div>\n</div>\n";